const megamenu = {
  links: document.querySelectorAll('.jsMenuDrop') as NodeListOf<HTMLElement>,

  init() {
    this.getPosition();
  },

  getPosition() {
    this.links.forEach((dropdown: HTMLElement) => {
      const container = document.getElementById('jsMegaMenu') as HTMLElement;
      const subList = dropdown.querySelector(
        '.desc-nav__sublist',
      ) as HTMLElement | null;
      const links = dropdown.querySelectorAll(
        '.desc-nav__subitem--lvl2',
      ) as NodeListOf<HTMLElement>;

      if (subList) {
        const subRect = subList.getBoundingClientRect().right;
        const containerRect = container.getBoundingClientRect().right;

        if (subRect > containerRect) {
          subList.style.left = 'auto';
        }
      }

      if (links.length < 15) {
        subList?.classList.add('activeClass');
      }
    });
  },
};

export default megamenu;
